import React, { useEffect, useRef } from 'react';

interface AdDesignsBannerProps {
  className?: string;
}

const AdDesignsBanner: React.FC<AdDesignsBannerProps> = ({ className }) => {
  const adContainerRef = useRef<HTMLDivElement>(null);
  const isScriptInjected = useRef(false);

  useEffect(() => {
    if (isScriptInjected.current || !adContainerRef.current) return;
    
    // Create and inject the script
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://cdn.diclotrans.com/sdk/v1/51381/809e5b5a89910d442c545b4de4bb5a8798ad3978/lib.js';
    script.async = true;
    
    // Append the script to the container
    adContainerRef.current.appendChild(script);
    
    isScriptInjected.current = true;
    
    // Cleanup function
    return () => {
      if (adContainerRef.current) {
        const scriptElement = adContainerRef.current.querySelector('script[src="https://cdn.diclotrans.com/sdk/v1/51381/809e5b5a89910d442c545b4de4bb5a8798ad3978/lib.js"]');
        if (scriptElement) {
          adContainerRef.current.removeChild(scriptElement);
        }
      }
      isScriptInjected.current = false;
    };
  }, []);

  return (
    <div className={`mx-auto ${className || ''}`} style={{ display: 'flex', justifyContent: 'center' }}>
      <div 
        ref={adContainerRef} 
        className="ad-designs-banner"
        style={{ 
          height: '250px', 
          width: '300px', 
          overflow: 'hidden',
          display: 'block',
          minWidth: '300px',
          minHeight: '250px'
        }}
      />
    </div>
  );
};

export default AdDesignsBanner;